import React, { useEffect, useState } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import CustomTable from "../../components/table/Table";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../redux/Slice/loaderSlice";
import { fetchCustomers, updateCustomer } from "../../redux/Slice/customerSlice";
import { toast } from "sonner";
import { clearMessage } from "../../redux/Slice/message";


export const InactiveCustomerlist = () => {

   const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const { profile } = useSelector((state) => state.auth);

  const getModule = profile?.permissions?.find(va => va.moduleName === "Customer Management" || va.moduleName === "*")?.actions;
  

   const { customers, totalPages, totalCount } = useSelector((state)=> state.customer);
  //  console.log("Customers:",customers);
   
 
   const modifiedRows = customers ? customers
   .filter((va) => !va?.status)
   .map((va, index)=> ({_id: va?._id, sno:index+1, customer_id: va?.customer_id,  contactPerson: `${va?.contactPerson[0]?.name} ,( ${va?.companyName} )`, contactInfo: `Email: ${va?.contactPerson[0]?.email} ,Mobile: ( ${va?.contactPerson[0]?.country_code} ) ${va?.contactPerson[0]?.phoneNumber}`, status: va?.status})) : [] ;

   const CustomerInactiveCount = customers ? customers.filter(va => !va?.status).length : 0;
   
  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    setPage(1);
  }

  const message = useSelector((state) => state.message);

  useEffect(() => {
    if (message?.message) {
      toast(message.message);
      dispatch(clearMessage());
    }
  }, [message, dispatch]); 

  const handleStatusChange = (row) => {
    console.log(row)
    const c_id = row._id;
        const formData = {
          status : !row.status 
        }
        dispatch(updateCustomer({c_id, formData}))
        .then(()=>{
          dispatch(setLoading(false));
        })
        .catch((error)=>{
          dispatch(setLoading(false));
        })
  };

  const handleEdit = () => {
  };

  const handleView = (val) => {
    navigate(`customerdetails/${val._id}`);
  };

  const columns = [
    { id: "customer_id", label: "Customer No", minWidth: 150, align: "start" },
    { id: "contactPerson", label: "Contact Person Name", minWidth: 150, align: "start" },
    { id: "contactInfo", label: "Contact Info", minWidth: 250, align: "start" },
    { id: 'status', label: 'Status', minWidth: 150, align: 'center' },

    {
      id: "action",
      label: "Action",
      minWidth: 150,
      align: "center",
      actionType: [{ view: true }],
    },
  ];

    useEffect(()=>{
      const params = {
        page: page,
        limit: rowsPerPage,
        searchTerm: searchTerm
      }
      if(getModule?.includes("customer_get") || getModule?.includes("*")){
      // dispatch(setLoading(true))
      dispatch(fetchCustomers(params))
      // .then(() => {
      //     dispatch(setLoading(false))
      //         })
      // .catch((error) => {
      //     dispatch(setLoading(false))
      //   })
      }
    }, [dispatch, getModule, page, rowsPerPage, searchTerm])

  

  return (
    <div className="content">
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography variant="h5" sx={{ mb: 3, mt: 3 }}>
          InActive Customer List <Typography component="span">({CustomerInactiveCount})</Typography>
        </Typography>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 3
          }}
        >
          <TextField
            placeholder="Search by Company Name"
            value={searchTerm} 
            onChange={handleSearch}
            fullWidth
          />
        
        </Box>
      </Box>

      <CustomTable
        columns={columns}
        rows={customers ? modifiedRows : []}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        handleEdit={handleEdit}
        handleView={handleView}
        handleStatusChange={handleStatusChange}
        totalCount={CustomerInactiveCount}
      />
    </div>
  );
};
